<template>
  <div id="full_page_setting" class="full_page_setting tab_content">
    <div class="setting-item">
      <el-button class="btn-add-slide" @click="onClickAddSlideBtn" icon="el-icon-plus">{{$t('view_left_sidebar_page_setting_full_page_setting_257')}}</el-button>
    </div>
    <div class="setting-item setting-item-nav">
      <p class="setting-item-title">{{ navLabel }}：</p>
      <div class="nav-setting-group setting-img-group">
        <div
          class="nav-setting-item"
          v-for="(item,i) in 4"
          :key="i"
          @click="onClickNavStyleItem(item,i)"
        >
          <label
            class="nav-setting-label setting-img-label"
            :class="$store.state.myRender.private.fullPageStyleType == i ? 'img-label-checked' : ''">
            <div class="jz_style_img style_item_img"
                 :class="['jz_style_img_' + i + ' style_item_'+i]">
              {{ i === 3 ? $t('view_left_sidebar_page_setting_full_page_setting_258') : '' }}
            </div>
          </label>
        </div>
      </div>
    </div>
    <div class="setting-item">
      <my_radio
        :title="$t('view_left_sidebar_page_setting_full_page_setting_259')"
        iconIsShow="left"
        titleWidth="66"
        :tips="$t('view_left_sidebar_page_setting_full_page_setting_260')"
        class="nav-type-title"
        :selectValue.sync="$store.state.myRender.common.fixed_header"
        :option="$store.state.options.topNavType"
        @change="fixed_init"
      >
      </my_radio>
      <span v-if="$store.state.myRender.common.header_display == 'true'" class="right-btn-setting setting-btn-nav"
            @click="changeTab('header')">{{$t('view_right_set_index_58')}}</span>
      <div class="setting-img-group setting-nav-style">
        <div
          class="setting-img-item"
          v-for="(item,i) in $store.state.options.fullPageTopNavType"
          :key="i"
          @click="onClickTopNavType(item)"
          @mouseenter="onMouseEnter(item,'header',i)"
          @mouseleave="onMouseLeave(item)"
        >
          <label
            class="setting-img-label"
            :class="$store.state.myRender.private.fullPageTopNavType== item.value ? 'img-label-checked' : ''"
          >
            <div class="jz_style_img style_item_img"
                 :class="['jz_style_img_' + i + ' style_item_'+i]">
              <img v-if="item.sampleImgVisible" class="gif-sample" :src="item.sampleImgUrl" alt="sample">
            </div>
          </label>
          <p class="setting-img-text">{{ $t(item.label) }}</p>
        </div>
      </div>
    </div>
    <div class="setting-item setting-footer-style">
      <p class="setting-item-title">{{$t('view_left_sidebar_page_setting_full_page_setting_261')}}<span v-if="$store.state.myRender.common.footer_display == 'true'" class="right-btn-setting"
              @click="changeTab('footer')">{{$t('view_right_set_index_58')}}</span></p>
      <div class="setting-img-group">
        <div
          class="setting-img-item"
          v-for="(item,i) in footerTypeOptions"
          :key="i"
          @click="onClickFooterType(item)"
          @mouseenter="onMouseEnter(item,'footer',i)"
          @mouseleave="onMouseLeave(item)"
        >
          <label
            class="setting-img-label"
            :class=" $store.state.myRender.private.fullPageFooterType == item.value ? 'img-label-checked' : ''"
          >
            <div class="jz_style_img style_item_img"
                 :class="['jz_style_img_' + i + ' style_item_'+i + ' style_item_'+item.value]">
              <div v-if="item.value==='hidden'" style="z-index: 0;">{{$t('view_left_sidebar_page_setting_full_page_setting_262')}}</div>
              <img v-if="item.sampleImgVisible && item.value!=='hidden'" class="gif-sample"
                   :src="item.sampleImgUrl"
                   alt="sample">
            </div>
          </label>
          <p class="setting-img-text">{{ $t(item.label) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'full_page_setting',
  data() {
    return {
      topNavSampleImgVisible: false,
      footerSampleImgVisible: false,
      topNavSampleImg: '',
      footerSampleImg: '',
    }
  },
  computed: {
    h_b() {
      return this.$store.state.myRender.common.header_background
    },
    f_b() {
      return this.$store.state.myRender.common.fixed_background
    },
    navLabel() {
      let scrollType = this.$store.state.app.scrollType
      return scrollType === 'col' ? i18n.t('view_left_sidebar_page_setting_full_page_setting_264') : i18n.t('view_left_sidebar_page_setting_full_page_setting_263')
    },
    footerTypeOptions() {
      return this.$store.state.app.scrollType === 'col' ? this.$store.state.options.footerType : this.$store.state.options.rowFooterType
    }
  },
  watch: {
    '$store.state.myRender.private.fullPageFooterType'(val) {
      if (val === 'hidden') {
        this.$store.commit('myRender/set_footer_display', 'false')
      } else {
        this.$store.commit('myRender/set_footer_display', 'true')
      }
    },
  },
  methods: {
    fixed_init() {
      this.templet.fixed_init();
      if (window.fullPage) {
        setTimeout(() => {
          window.fullPage.resetHeight()
        }, 200)
      }
    },
    onClickAddSlideBtn() {
      if(this.$store.state.app.scrollType !== 'normal' && this.$store.state.app.view_pattern === "pc") { //新增全屏通栏
          const page = [...document.querySelectorAll('#full-page-nav li')];
          if(page.length > 14) {
            this.$message.warning(i18n.t('view_left_sidebar_module_add_module_243'))
            return
          }
      }
      this.templet.add_row(this.$store.state.app.fullPageCurrentIndex, this.$store.state.app.module_Data || this.$store.state.myRender.body[0])
      if (window.fullPage) {
        setTimeout(() => {
          window.fullPage.resetData()
          window.fullPage.resetHeight()
          if (this.$store.state.myRender.private.banner_isShow) {
            // 如果有横幅，就要往下滚一页
            window.fullPage.next()
          }
        }, 200)
      }
    },
    onClickNavStyleItem(item, i) {
      this.$store.commit('myRender/setFullPageStyleType', i)
    },
    onClickTopNavType(item) {
      this.$store.commit('myRender/setFullPageTopNavType', item.value)
    },
    onClickFooterType(item) {
      this.$store.commit('myRender/setFullPageFooterType', item.value)
    },
    onMouseEnter(item, type) {
      let scrollType = this.$store.state.app.scrollType
      let urlMap = {
        header: {
          'fixed_xuanfu_col': '/static/image/fullpage/scroll_page_header1.gif',
          'fixed_zhanwei_col': '/static/image/fullpage/scroll_page_header2.gif',
          'unfixed_xuanfu_col': '/static/image/fullpage/scroll_page_header3.gif',
          'unfixed_zhanwei_col': '/static/image/fullpage/scroll_page_header4.gif',
          'fixed_xuanfu_row': '/static/image/fullpage/scroll_page_row_header1.gif',
          'fixed_zhanwei_row': '/static/image/fullpage/scroll_page_row_header2.gif',
          'unfixed_xuanfu_row': '/static/image/fullpage/scroll_page_row_header1.gif',
          'unfixed_zhanwei_row': '/static/image/fullpage/scroll_page_row_header2.gif',
        },
        footer: {
          'type0_col': '/static/image/fullpage/scroll_page_footer1.gif',
          'type1_col': '/static/image/fullpage/scroll_page_footer2.gif',
          'typeRow1_row': '/static/image/fullpage/scroll_page_row_footer.gif',
        }
      }
      let url
      if (type === 'header') {
        let fixedStr = String(this.$store.state.myRender.common.fixed_header) === 'true' ? 'fixed' : 'unfixed'
        url = urlMap.header[`${fixedStr}_${item.value}_${scrollType}`]
      } else if (type === 'footer') {
        url = urlMap.footer[item.value + '_' + scrollType]
      }
      // 新增属性直接赋值 视图没有自动更新
      this.$set(item, 'sampleImgVisible', true)
      this.$set(item, 'sampleImgUrl', url)
    },
    onMouseLeave(item) {
      this.$set(item, 'sampleImgVisible', false)
    },
    changeTab(tabName) {
      this.$emit('changeTab', tabName)
    },
    fixDefaultValue() {
      let scrollType = this.$store.state.app.scrollType
      let fullPageFooterType = this.$store.state.myRender.private.fullPageFooterType
      if (!this.footerTypeOptions.some(item => item.value === fullPageFooterType)) {
        let defaultFooterType = scrollType === 'col' ? 'type0' : 'typeRow1'
        this.$store.commit('myRender/setFullPageFooterType', defaultFooterType)
      }
    }
  },
  mounted() {
    this.fixDefaultValue()
  }
}
</script>

<style lang="scss" scoped>

.full_page_setting {
  $main-color: #0078d7;

  &.tab_content {
    padding-left: 25px;
    padding-right: 25px;
  }

  .setting-item {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .btn-add-slide {
    width: 325px;
    border: 1px solid $main-color;
    color: $main-color;


    &:hover {
      background: $main-color;
      color: #fff;
    }
  }

  .setting-item-title {
    font-size: 13px;
    margin-bottom: 8px;
  }


  .setting-img-group {
    display: flex;
    justify-content: space-between;

    .setting-img-label {
      display: inline-block;
      border: 1px solid #e7e7eb;
      overflow: hidden;
      position: relative;

      &:hover {
        border-color: #5874d8;
      }

      &.img-label-checked {
        border-color: #5874d8;
      }

      &.img-label-checked:after {
        position: absolute;
        right: 0;
        bottom: 0;
        content: "";
        width: 28px;
        height: 24px;
        background: url(/static/image/component.png) no-repeat -197px -24px;
        z-index: 2;
      }
    }

    .style_item_img {
      background: url(/static/image/moduleBg.png) no-repeat;
      width: 70px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
    }

    .setting-img-text {
      text-align: center;
      line-height: 30px;
    }


    img.gif-sample {
      width: 156px;
      height: 94px;
      vertical-align: top;
    }
  }

  .setting-item-nav {
    .style_item_img {
      background: url(/static/image/css_sprites_yang.png) no-repeat;
      background-color: var(--theme_color);
      background-size: 396px 284px;
      width: 70px;
      height: 70px;
      border-radius: 4px;
    }

    .style_item_0 {
      background-position: -5px -5px;
    }

    .style_item_1 {
      background-position: -85px -5px;
    }

    .style_item_2 {
      background-position: -5px -85px;
    }

    .style_item_3 {
      background-image: none;
      background-color: #fff;
    }
  }

  .nav-type-title {
    margin-bottom: 3px;
    width: 250px;
    display: inline-block;
  }

  // 顶部类型：悬浮/占位
  .setting-img-group.setting-nav-style {
    .style_item_img {
      width: 156px;
      height: 94px;
      line-height: 94px;
    }

    .style_item_0 {
      background: url(/static/image/fullpage/scroll_page_header1.png) no-repeat;
    }

    .style_item_1 {
      background: url(/static/image/fullpage/scroll_page_header2.png) no-repeat;
    }
  }

  //  底部类型
  .setting-footer-style {
    .setting-img-group {
      flex-wrap: wrap;
    }

    .setting-img-item {
      margin-right: 2px;
    }

    .style_item_img {
      width: 156px;
      height: 94px;
      line-height: 94px;
      background-color: transparent;
    }

    .style_item_0 {
      background: url(/static/image/fullpage/scroll_page_footer1.png) no-repeat;

    }

    .style_item_1 {
      background: url(/static/image/fullpage/scroll_page_footer1.png) no-repeat;
    }

    .style_item_2, .style_item_hidden {
      background-image: none;
      position: relative;
    }

    .style_item_2::before, .style_item_hidden:before {
      content: '';
      position: absolute;
      width: 130px;
      height: 68px;
      background: #e8f0fc;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

  }

  .right-btn-setting {
    float: right;
    cursor: pointer;

    &:hover {
      color: #0078d7;
    }
  }

  .setting-btn-nav {
    height: 32px;
    line-height: 32px;
  }

}
</style>
<style lang="scss">
.full-page-row .full_page_setting .setting-item-nav {
  .style_item_img {
    background: url(/static/image/css_sprites_yang.png) no-repeat;
    background-color: var(--theme_color);
    background-size: 396px 284px;
    width: 70px;
    height: 70px;
  }

  .style_item_0 {
    background-position: -85px -85px;
  }

  .style_item_1 {
    background-position: -165px -5px;
  }

  .style_item_2 {
    background-position: -165px -85px;
  }

  .style_item_3 {
    background-image: none;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page_setting/full_page_setting.vue